module.exports = __webpack_public_path__ + "img/data-center08.1e559321.png";